module.exports = __webpack_public_path__ + "img/57.d2d78b7.jpg";